module.exports = __webpack_public_path__ + "static/img/defaultPage.bec87573.png";